import axios from "axios";
import * as actionType from "../constants/actionTypes";
// let qs = require("qs");

/*** SignIn Action ***/
export const SignInStart = () => {
    return {
        error: null,
        loader: true,
        type: actionType.SignIn_START,
    };
};
export const SignInSuccess = (response) => {
    return {
        token: false,
        loader: false,
        type: actionType.SignIn_SUCCESS,
    };
};
export const SignInFail = (error) => {
    return {
        error: error,
        loader: false,
        type: actionType.SignIn_FAIL,
    };
};
export const SignIn = (form_data) => {
    return (dispatch) => {
        dispatch(SignInStart());

        let formdata = new FormData();
        for (let key in form_data) {
            formdata.append(key, form_data[key]);
        }

        return axios({
            method: "post",
            data: formdata,
            url: `${actionType.environment_url}/api/SignIn`,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((response) => {
                console.log("responseinlogin", response.data.data);

                // Case: 2FA (QR code step)
                if (response.data.qrcode && response.data.twof_auth == true) {
                    return response.data;
                }
                if (response.data.requires2FA == true && response.data.twof_auth == true) {
                    
                    return response.data;
                }
                // Case: normal login success
                if (response.data.success === true && response.data.token) {
                    console.log(response.data.data ,"response.data.data")
                    localStorage.setItem("bss_authtoken", response.data.token);
                    localStorage.setItem(
                        "bss_authuser",
                        JSON.stringify(response.data.data)
                    );

                    if (response.data.data?.role_type !== 1) {
                        const authUser = JSON.parse(localStorage.getItem("bss_authuser"));

                        const autoLogoutSettings = {
                            neverLogout: authUser?.user_school?.never_logout,
                            logoutTimeMinutes: authUser?.user_school?.auto_logout_time,
                        };

                        sessionStorage.setItem(
                            "autoLogoutSettings",
                            JSON.stringify(autoLogoutSettings)
                        );
                    }
                    else if (response.data.data?.role_type == 1){
                           const authUser = JSON.parse(localStorage.getItem("bss_authuser"));

                        const autoLogoutSettings = {
                            neverLogout: authUser?.settings?.never_logout,
                            logoutTimeMinutes: authUser?.settings?.auto_logout_time,
                        };

                        sessionStorage.setItem(
                            "autoLogoutSettings",
                            JSON.stringify(autoLogoutSettings)
                        );
                    }

                    dispatch(SignInSuccess("User login successfully !!!"));
                }

                return response.data;
            })
            .catch((error) => {
                dispatch(SignInFail("Something went wrong, Please try again."));
                return error;
            });
    };
};
// export const SignIn = (form_data) => {
//     return (dispatch) => {
//         dispatch(SignInStart());

//         let formdata = new FormData();
//         for (let key in form_data) {
//             formdata.append(key, form_data[key]);
//         }

//         return axios({
//             method: "post",
//             data: formdata,
//             url: `${actionType.environment_url}/api/SignIn`,
//             headers: { "Content-Type": "multipart/form-data" },
//         })
//             .then(function (response) {
//                 console.log("responseinlogin", response);
                
//                 if (response.data.success === true) {
//                     localStorage.setItem("bss_authtoken", response.data.token);
//                     localStorage.setItem("bss_authuser", JSON.stringify(response.data.data));
//                     if (response.data.data?.role_id !== 1) {
//                         const authUser = JSON.parse(localStorage.getItem("bss_authuser"));

//                     const autoLogoutSettings = {
//                         neverLogout: authUser?.user_school?.never_logout ,
//                         logoutTimeMinutes: authUser?.user_school?.auto_logout_time ,
//                     };

//                     localStorage.setItem(
//                         "autoLogoutSettings",
//                         JSON.stringify(autoLogoutSettings)
//                     )}
//                 }
//                 dispatch(SignInSuccess("User login successfully !!!"));
//                 return response.data;
//             })
//             .catch(function (error) {
//                 dispatch(SignInFail("Something went wrong, Please try again."));
//                 return error;
//             });
//     };
// };




// Add these action creators alongside your existing SignIn actions

export const Verify2FAStart = () => {
    return {
        error: null,
        loader: true,
        type: actionType.Verify2FA_START,
    };
};

export const Verify2FASuccess = (response) => {
    return {
        token: false,
        loader: false,
        type: actionType.Verify2FA_SUCCESS,
    };
};

export const Verify2FAFail = (error) => {
    return {
        error: error,
        loader: false,
        type: actionType.Verify2FA_FAIL,
    };
};

export const Verify2FA = (form_data) => {
    return (dispatch) => {
        dispatch(Verify2FAStart());

        let formdata = new FormData();
        for (let key in form_data) {
            formdata.append(key, form_data[key]);
        }

        return axios({
            method: "post",
            data: formdata,
            url: `${actionType.environment_url}/api/Verify2FA`,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((response) => {
                console.log("responseinVerify2FA", response);

                // Case: OTP verification success
                if (response.data.success === true && response.data.token) {
                    localStorage.setItem("bss_authtoken", response.data.token);
                    localStorage.setItem(
                        "bss_authuser",
                        JSON.stringify(response.data.data)
                    );

                    if (response.data.data?.role_id !== 1) {
                        const authUser = JSON.parse(localStorage.getItem("bss_authuser"));

                        const autoLogoutSettings = {
                            neverLogout: authUser?.user_school?.never_logout,
                            logoutTimeMinutes: authUser?.user_school?.auto_logout_time,
                        };

                        localStorage.setItem(
                            "autoLogoutSettings",
                            JSON.stringify(autoLogoutSettings)
                        );
                    }

                    dispatch(Verify2FASuccess("2FA verification successful !!!"));
                }

                return response.data;
            })
            .catch((error) => {
                dispatch(Verify2FAFail("Something went wrong, Please try again."));
                return error;
            });
    };
}; 

// resetLink 
// ✅ 2FA Reset Link Actions
export const Send2FAResetLinkStart = () => {
    return {
        error: null,
        loader: true,
        type: actionType.SEND_2FA_RESET_LINK_START,
    };
};

export const Send2FAResetLinkSuccess = (message) => {
    return {
        token: false,
        loader: false,
        type: actionType.SEND_2FA_RESET_LINK_SUCCESS,
        payload: message,
    };
};

export const Send2FAResetLinkFail = (error) => {
    return {
        error: error,
        loader: false,
        type: actionType.SEND_2FA_RESET_LINK_FAIL,
    };
};

export const Send2FAResetLink = (form_data) => {
    return (dispatch) => {
        dispatch(Send2FAResetLinkStart());

        let formdata = new FormData();
        for (let key in form_data) {
            formdata.append(key, form_data[key]);
        }

        return axios({
            method: "post",
            data: formdata,
            url: `${actionType.environment_url}/api/Send2FAResetLink`,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((response) => {
                console.log("responseInSend2FAResetLink", response);

                if (response.data.success === true) {
                    dispatch(Send2FAResetLinkSuccess("2FA reset link sent successfully!"));
                }

                return response.data;
            })
            .catch((error) => {
                dispatch(
                    Send2FAResetLinkFail("Something went wrong, Please try again.")
                );
                return error;
            });
    };
};

// 

export const isAuthorize = () => {
    const bss_authuser = localStorage.getItem("bss_authuser");
    const bss_authtoken = localStorage.getItem("bss_authtoken");
    if (bss_authuser !== null && bss_authtoken !== null) {
        return bss_authtoken ? true : false;
    }
    //return bss_authtoken ? true : false;
};

/*** Logout Action ***/
export const logout = () => {
    return axios({
        method: "post",
        url: `${actionType.environment_url}/api/Logout`,
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("bss_authtoken")}`,
        },
    })
        .then(function (response) {
            if (response.data.Success === true) {
                localStorage.removeItem("bss_authuser");
                localStorage.removeItem("autoLogoutSettings")
                localStorage.removeItem("bss_authtoken");
                localStorage.removeItem("Rollcal_Final");
                localStorage.removeItem("Rollcal_List");
                localStorage.removeItem("Rollcal_Data_Global");
                localStorage.removeItem("RollCall_time");
                localStorage.removeItem("SessionName");
                localStorage.removeItem("ModalShownStudents");

                localStorage.removeItem("Dormitory_filters");
                localStorage.removeItem("Class_filters");
                localStorage.removeItem("Gender_filters");
                localStorage.removeItem("role_id");
                localStorage.removeItem("user_uuid");

                localStorage.removeItem("permissions");
                // localStorage.removeItem("check_box_all");
                localStorage.removeItem("status_select_all");

                localStorage.removeItem("Manager_id");
                localStorage.removeItem("Socket_calls");

            }
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
};


/*** ForgotPassword Action ***/
export const ForgotPasswordStart = () => {
    return {
        error: null,
        loader: true,
        type: actionType.ForgotPassword_START,
    };
};
export const ForgotPasswordSuccess = (response) => {
    return {
        token: false,
        loader: false,
        type: actionType.ForgotPassword_SUCCESS,
    };
};
export const ForgotPasswordFail = (error) => {
    return {
        error: error,
        loader: false,
        type: actionType.ForgotPassword_FAIL,
    };
};
export const ForgotPassword = (form_data) => {
    return (dispatch) => {
        dispatch(ForgotPasswordStart());

        let formdata = new FormData();
        for (let key in form_data) {
            formdata.append(key, form_data[key]);
        }

        return axios({
            method: "post",
            data: formdata,
            url: `${actionType.environment_url}/api/ForgotPassword`,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then(function (response) {
                dispatch(ForgotPasswordSuccess("User login successfully !!!"));
                return response.data;
            })
            .catch(function (error) {
                dispatch(ForgotPasswordFail("Something went wrong, Please try again."));
                return error;
            });
    };
};

/*** ResetPassword Action ***/
export const ResetPasswordStart = () => {
    return {
        error: null,
        loader: true,
        type: actionType.ResetPassword_START,
    };
};
export const ResetPasswordSuccess = (response) => {
    return {
        token: false,
        loader: false,
        type: actionType.ResetPassword_SUCCESS,
    };
};
export const ResetPasswordFail = (error) => {
    return {
        error: error,
        loader: false,
        type: actionType.ResetPassword_FAIL,
    };
};
export const ResetPassword = (form_data) => {
    return (dispatch) => {
        dispatch(ResetPasswordStart());

        let formdata = new FormData();
        for (let key in form_data) {
            formdata.append(key, form_data[key]);
        }

        return axios({
            method: "post",
            data: formdata,
            url: `${actionType.environment_url}/api/ResetPassword`,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then(function (response) {
                dispatch(ResetPasswordSuccess("User login successfully !!!"));
                return response.data;
            })
            .catch(function (error) {
                dispatch(ResetPasswordFail("Something went wrong, Please try again."));
                return error;
            });
    };
};

// Send a one-time email OTP to the user's email address
export const SendEmailOtpStart = () => ({
    error: null,
    loader: true,
    type: actionType.SEND_EMAIL_OTP_START,
});

export const SendEmailOtpSuccess = (message) => ({
    token: false,
    loader: false,
    type: actionType.SEND_EMAIL_OTP_SUCCESS,
    payload: message,
});

export const SendEmailOtpFail = (error) => ({
    error: error,
    loader: false,
    type: actionType.SEND_EMAIL_OTP_FAIL,
});

export const SendEmailOtp = (form_data) => {
    return (dispatch) => {
        dispatch(SendEmailOtpStart());

        let formdata = new FormData();
        for (let key in form_data) {
            formdata.append(key, form_data[key]);
        }

        return axios({
            method: "post",
            data: formdata,
            url: `${actionType.environment_url}/api/Send2FAEmailOTP`,
            headers: { "Content-Type": "multipart/form-data" },
        })
            .then((response) => {
                console.log("responseInSendEmailOtp", response);

                if (response.data.success === true) {
                    dispatch(SendEmailOtpSuccess(response.data.message || "Email OTP sent."));
                }

                return response.data;
            })
            .catch((error) => {
                dispatch(SendEmailOtpFail("Something went wrong, Please try again."));
                return error;
            });
    };
};